export default __webpack_public_path__ + "assets/stocked-fridge/stocked-fridge-main.3709100dca8b355a105e1d4ee048d7c8.webp";